// extracted by mini-css-extract-plugin
module.exports = {"blade-I":"KolSection_blade-I__CWglr"};